import {
  type ControlConfiguration,
  QuoteControlType,
} from '@src/components/sidepanel/CompositionSettings/types';
import {
  Button,
  CaretDownIcon,
  CaretUpIcon,
  Dropdown,
  DropdownMenu,
  DropdownOption,
  TextInput,
} from 'datocms-react-ui';

type TextControlSelectorProps = {
  control: ControlConfiguration & { enabled?: boolean };
  onUpdateCustomValue: (
    newValue:
      | {
          value?: string | number;
          quote?: QuoteControlType;
        }
      | undefined,
  ) => void;
  isCustomValue: boolean;
  customValue: string | undefined;
  setCustomValue: (value: string | undefined) => void;
};

const getDisplayValue = (control: ControlConfiguration) => {
  if (
    control.default?.value !== undefined &&
    control.default?.value !== null &&
    control.default?.value !== ''
  ) {
    return String(control.default.value);
  } else if (
    control.default?.quote !== undefined &&
    control.default?.quote !== null
  ) {
    return 'Quote ' + String(control.default.quote);
  }
  return 'None';
};

export function TextControlSelector({
  control,
  onUpdateCustomValue,
  isCustomValue,
  customValue,
  setCustomValue,
}: TextControlSelectorProps) {
  const displayValue = getDisplayValue(control);
  const isNumber = control.type === 'number';

  return (
    <Dropdown
      renderTrigger={({ open, onClick }) => (
        <Button
          buttonSize="xxs"
          type="button"
          onClick={onClick}
          rightIcon={open ? <CaretUpIcon /> : <CaretDownIcon />}
        >
          <span>{displayValue}</span>
        </Button>
      )}
    >
      <DropdownMenu>
        <DropdownOption
          active={displayValue === 'None' && !control.default?.quote}
          onClick={() => {
            onUpdateCustomValue(undefined);
            setCustomValue(undefined);
          }}
        >
          None
        </DropdownOption>
        <DropdownOption
          active={isCustomValue}
          onClick={() => {
            const initialValue =
              control.default?.value !== undefined
                ? String(control.default.value)
                : '';
            onUpdateCustomValue({ value: initialValue });
            setCustomValue(initialValue);
          }}
          closeMenuOnClick={false}
        >
          {isCustomValue ? (
            <TextInput
              type={isNumber ? 'number' : 'text'}
              value={customValue}
              onChange={value => {
                setCustomValue(value);
                onUpdateCustomValue({
                  value: isNumber && value ? Number(value) : value,
                });
              }}
              placeholder={isNumber ? 'Enter number' : 'Enter text'}
            />
          ) : (
            'Custom Value'
          )}
        </DropdownOption>

        <DropdownOption
          active={
            displayValue === 'None' &&
            control.default?.quote === QuoteControlType.TEXT
          }
          onClick={() => {
            onUpdateCustomValue({ quote: QuoteControlType.TEXT });
            setCustomValue(undefined);
          }}
        >
          Quote Text
        </DropdownOption>
        <DropdownOption
          active={
            displayValue === 'None' &&
            control.default?.quote === QuoteControlType.NAME
          }
          onClick={() => {
            onUpdateCustomValue({ quote: QuoteControlType.NAME });
            setCustomValue(undefined);
          }}
        >
          Quote Name
        </DropdownOption>
        <DropdownOption
          active={
            displayValue === 'None' &&
            control.default?.quote === QuoteControlType.ORG
          }
          onClick={() => {
            onUpdateCustomValue({ quote: QuoteControlType.ORG });
            setCustomValue(undefined);
          }}
        >
          Quote Org
        </DropdownOption>
      </DropdownMenu>
    </Dropdown>
  );
}
